import { Weave } from '../../models/weave';
import data from './data.json';

const weaves = (data.weaves as unknown as Weave[]);
const rates = data.rates as unknown as { [key: number]: number[] };

weaves.forEach((v, i) => v.idNum = i + 1);

class WeaveTrainerData {
  getWeaves(): Weave[] {
    return weaves;
  }
  
  getRates() {
    return rates;
  }
}

export const weaveTrainerData = new WeaveTrainerData();

for (let weave of weaves) {
  weave.percentStart = 0;
  weave.percentTarget = 0;

  weave.percentActual = 0;
  weave.pracsActual = 0;
  weave.pracsCount = 0;
  weave.percentHistory = [];

  weave.percentActual2 = 0;
  weave.percentHistory2 = [];
  weave.pracsActual2 = 0;
  weave.pracsCount2 = 0;
}

console.log(weaves);





/*
for (let weave of weaves) {
  weave.id = weave.name.replaceAll(' ', '_').toLowerCase();
  weave.name = weave.name.split(' ').map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(' ');
  weave.name = weave.name.replace(' Vs ', ' vs ').replace(' Of ', ' of ');
  weave.residualGroup = (weave.residualGroup || '').toString();
  weave.residualIds= [];
}

for (let group of Object.values(groupBy(weaves.filter(x => x.residualGroup), x => x.residualGroup))) {

  for (let weave of group) {
    weave.residualIds = [];
    weave.residualIds = group.filter(x => x.id !== weave.id).map(x => x.id);
  }

}



function cleanupJson(objs: any[]) {
  for (let obj of objs) {
    const keys = Object.keys(obj);
    const id = keys.filter(x => x == 'id');
    const name = keys.filter(x => x == 'name');
    const resid = keys.filter(x => x == 'residualGroup');
    const ele = keys.filter(x => ['earth','air','fire','water','spirit'].includes(x));
    const ids = keys.filter(x => x.indexOf('Id') !== -1).sort((a, b) => a[0].localeCompare(b[0]));
    const other = keys.filter(x => x !== 'id' && x !== 'name' && x.indexOf('Id') === -1 && x !== 'residualGroup' && !['earth','air','fire','water','spirit'].includes(x)).sort((a, b) => a[0].localeCompare(b[0]));

    ele.sort((a, b) => ['earth','air','fire','water','spirit'].indexOf(a) - ['earth','air','fire','water','spirit'].indexOf(b));

    const newKeys = id.concat(name).concat(other).concat(ele).concat(resid).concat(ids);

    for (let key of newKeys) {
      const value = obj[key];
      delete obj[key];
      obj[key] = value;
    }
  }

  
  console.log(JSON.stringify(objs, null, 2));
}


cleanupJson(weaves);
//console.log(JSON.stringify(weaves, null, 2));


*/
